const makeAsync =
  (fn) =>
  (...args) =>
    setTimeout(() => fn.apply(this, args), 0);

export default makeAsync;
